import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserIndustryResponse } from '../interface/fee.interface';

export interface FeeHeaderContext {
  groupName: string;
  subgroupName: string;
  groupId?: number;
  subgroupId?: number;
}

@Injectable({ providedIn: 'root' })
export class FeeStateService {

  private readonly _activeUserIndustry$ = new BehaviorSubject<UserIndustryResponse | null>(null);
  readonly activeUserIndustry$ = this._activeUserIndustry$.asObservable();

  private readonly _hasGroups$ = new BehaviorSubject<boolean>(false);
  readonly hasGroups$ = this._hasGroups$.asObservable();

  private readonly _feeHeaderContext$ = new BehaviorSubject<FeeHeaderContext | null>(null);
  readonly feeHeaderContext$ = this._feeHeaderContext$.asObservable();

  setActiveUserIndustry(userIndustry: UserIndustryResponse | null): void {
    this._activeUserIndustry$.next(userIndustry);
  }

  setHasGroups(value: boolean): void {
    this._hasGroups$.next(value);
  }

  setFeeHeaderContext(context: FeeHeaderContext | null): void {
    this._feeHeaderContext$.next(context);
  }

  get snapshot(): UserIndustryResponse | null {
    return this._activeUserIndustry$.getValue();
  }
}
